import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./RegisterPalletForm";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelModifyOtherPallet} from "../../../actions/InventoryApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence, validateGreaterThan} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "palletId");
  errors = validatePresence(errors, values, "inventorySku");
  errors = validateGreaterThan(errors, values, "quantity", 0);
  return errors.toJS();
}

class ModifyOtherPalletFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.modifyPallet(values.toJS())
      .then((response) => {
        if (response.data.modifyPallet.errors.length <= 0) {
          this.props.cancelModifyOtherPallet();
        } else {
          let errors = createValidationErrors(response.data.modifyPallet.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelModifyOtherPallet();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let initialValues = fromJS({
      palletId: data.pallet.palletId,
      inventorySku: data.pallet.sku,
      quantity: data.pallet.quantity
    });
    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        products={fromJS(data.products)}
        activatePalletId={false}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}

const MODIFY_PALLET = gql`
  mutation modifyPallet($data: PalletInput!) {
    modifyPallet(input: $data) {
      errors { key message }
    }
  }
`

const PALLET_AND_PRODUCTS = gql`
  query palletAndProducts($palletId: ID!, $type: String) {
    pallet(palletId: $palletId) {
      createdAt
      quantity
      palletId
      sku
      state
    }
    products(type: $type) {
      sku
      title
      type
      nrBundled
    }
  }
`

const withQueries = compose(
  graphql(PALLET_AND_PRODUCTS, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        palletId: props.palletId,
        type: "dispenser_and_packaging"
      }      
    })
  }),
  graphql(MODIFY_PALLET, {
    props: ({ mutate }) => ({
      modifyPallet: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {cancelModifyOtherPallet})(withQueries(ModifyOtherPalletFormContainer));